// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
ion-icon-obsolete[class*=beerhive-] {
  width: 25px;
  height: 25px;
  position: relative;
  top: 5px;
  /*display: block;*/
  /*margin: auto;*/
}
ion-icon-obsolete[class*=beerhive-icon-bee] {
  content: url(/assets/svg/icon_bee.svg);
}
ion-icon-obsolete[class*=beerhive-icon] {
  content: url(/assets/svg/icon_beerhive.svg);
}
ion-icon-obsolete[class*=beerhive-icon-menu-myanalysis] {
  content: url(/assets/svg/icon_menu_myAnalysis_2.svg);
}
ion-icon-obsolete[class*=beerhive-icon-menu-wishlist] {
  content: url(/assets/svg/icon_wishlist_menu.svg);
}
ion-icon-obsolete[class*=beerhive-icon-sight] {
  content: url(/assets/svg/icon_sight.svg);
}
ion-icon-obsolete[class*=beerhive-icon-menu-faq] {
  content: url(/assets/svg/icon_menu_faq.svg);
}
ion-icon-obsolete[class*=beerhive-icon-menu-logout] {
  content: url(/assets/svg/icon_menu_logout.svg);
}
ion-icon-obsolete[class*=beerhive-icon-venue-filter-0] {
  content: url(/assets/svg/icon_location_0.svg);
}
ion-icon-obsolete[class*=beerhive-icon-venue-filter-1] {
  content: url(/assets/svg/icon_location_1.svg);
}

@font-face {
  font-family: "Century Gothic";
  src: url('century-gothic.42797046622fea43.ttf'), url('century-gothic-bold.32c4fc45a3029d3d.ttf');
  font-style: normal;
}
@font-face {
  font-family: "Century Gothic";
  src: url('century-gothic-bold.32c4fc45a3029d3d.ttf'), url('century-gothic-bold.32c4fc45a3029d3d.ttf');
  font-style: normal;
  font-weight: bold;
}
* {
  font-family: "Century Gothic";
  font-weight: normal;
  color: #5D4C44;
}

.bhbold {
  font-family: "Century Gothic";
  font-weight: bold;
}

.label-md {
  /*line-height: 46px;*/
  /*margin: auto;*/
}

.appinfo {
  font-family: "Century Gothic";
  font-size: 11px;
  font-weight: bold;
  margin-bottom: 5px;
  margin-top: 15px;
  text-align: center;
}

/*.list-ios > .item-block, .list-ios > .item-wrapper .item-block {
    border-bottom: 2.55px solid #c8c7cc;
}*/
/*ion-header.header.header-md {
    height: 0px;
}*/
/*element.style {
    height: 0px;
}*/
.venue-filter-popover .popover-content {
  width: 275px;
}

.ios .location-icon {
  width: 32px;
  height: 29px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
